import { useState } from "react";
import { FAQS } from "../../../mocks/newsData";

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(FAQ_SCHEMA) }} />
      <section className="border-y border-background-200 bg-background-100/70" id="faq">
        <div className="mx-auto max-w-[1440px] px-4 py-10 md:px-6 md:py-14">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
            <div className="lg:col-span-4">
              <div className="flex items-center gap-2">
                <span className="h-5 w-1 rounded-full bg-accent-500" aria-hidden="true" />
                <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">热点问答</h2>
              </div>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                关于实时爆料的信源核实、内容原则与使用方式，这里是读者最常问到的几个问题。如果你的疑问不在其中，欢迎通过线索征集告诉我们。
              </p>
              <div className="mt-5 rounded-lg bg-background-50 p-4">
                <p className="flex items-center gap-2 text-xs font-medium text-foreground-500">
                  <i className="ri-questionnaire-line text-primary-500" aria-hidden="true" /> 仍有疑问？
                </p>
                <a
                  href="#contact"
                  className="mt-2 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
                >
                  联系编辑部
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </a>
              </div>
            </div>

            <div className="space-y-3 lg:col-span-8">
              {FAQS.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={index}
                    className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center gap-3 px-4 py-4 text-left"
                      aria-expanded={isOpen}
                    >
                      <span className="font-label text-sm font-bold text-accent-600">Q{index + 1}</span>
                      <span className="flex-1 text-sm font-medium leading-6 text-foreground-900 md:text-base">
                        {faq.q}
                      </span>
                      <i
                        className={
                          isOpen
                            ? "ri-subtract-line text-lg text-primary-500"
                            : "ri-add-line text-lg text-foreground-400"
                        }
                        aria-hidden="true"
                      />
                    </button>
                    {isOpen && (
                      <div className="border-t border-background-200 bg-background-100/50 px-4 py-4 pl-11 text-sm leading-7 text-foreground-700">
                        {faq.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}